import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "@/views/DashboardView.vue";
import Analytics from "@/views/AnalyticsView.vue";
import Forecast from "@/views/ForecastView.vue";
import Report from "@/views/ReportView.vue";

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: "/analytics",
    name: "Analytics",
    component: Analytics,
  },
  {
    path: "/forecast",
    name: "Forecast",
    component: Forecast,
  },
  {
    path: "/reports",
    name: "Report",
    component: Report,
  },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});
